import { render, staticRenderFns } from "./study-activities.vue?vue&type=template&id=1a490412&scoped=true&"
import script from "./study-activities.vue?vue&type=script&lang=js&"
export * from "./study-activities.vue?vue&type=script&lang=js&"
import style0 from "./study-activities.vue?vue&type=style&index=0&id=1a490412&scoped=true&lang=scss&"
import style1 from "./study-activities.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a490412",
  null
  
)

component.options.__file = "study-activities.vue"
export default component.exports